import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { TeamCreatePage } from '@/features/org/components/team-form-page'
import { TEAMS_SEARCH_DEFAULTS, teamsSearchSchema } from '@/features/org/search-schema'

/**
 * /teams/new —— 新建团队(名称 + 上级团队,可设为根)。
 * 与员工侧同构:独立路由页、复用列表 search schema、提交完 / 取消都带着筛选回列表。
 */
export const Route = createFileRoute('/_authed/teams/new')({
  validateSearch: teamsSearchSchema,
  search: {
    middlewares: [stripSearchParams(TEAMS_SEARCH_DEFAULTS)],
  },
  component: TeamCreatePage,
})
